import React from 'react'
import { Helmet } from 'react-helmet-async';
import './UiService.css'
// import Testimonials from './Testimonials/Testimonials'
import Uifooter from './UiFooter/Uifooter'
import Industries from './Industries/Industries'
import Process from './Processs/Process'
import Heroui from './Heroui/Heroui'
import Whatwedo from './Whatwedo/Whatwedo'
import Aboutui from './Aboutui/Aboutui'
import Whyui from './Whyui/Whyui'
function UiService() {
  return (
    <div id='uiuxservice'>
      <Helmet>
        <title>UI/UX Design Services | User Experience Design | BastionEx</title>
        <meta name="description" content="Professional UI/UX design services creating stunning user experiences. Custom interface design for web and mobile apps. Award-winning solutions." />
        <link rel="canonical" href="https://bastionex.net/ui-ux-service" />
      </Helmet>
      <Heroui />
      <Aboutui />
      <Whatwedo />
      <Whyui />
      <Process />
      <Industries />
      <Uifooter />
    </div>
  )
}

export default UiService